import React from 'react';
import { TableRow, TableCell, Tooltip, Chip } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import ProgressDonut from './ProgressDonut';
import StatusBadge from './StatusBadge';
import { STATUS_META } from '../constants';
import { formatPlanDate, isLaunchingSoon, daysUntilStart } from '../utils';
import { displayDateTime12HrsFormatShort } from '../../../../constants';
import moment from 'moment';

const TRUNCATE_STYLE = { maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block' };

const TruncatedText = ({ text, maxLength = 20 }) => {
  if (!text) return null;
  const content = <span style={TRUNCATE_STYLE}>{text}</span>;
  return String(text).length > maxLength ? <Tooltip title={text} arrow>{content}</Tooltip> : content;
};

const PlannerList = ({ plan, canChangeStatus, canEditStage, onView, onEdit, onDelete, onChangeStatus, onEditStage }) => {
  const soon = isLaunchingSoon(plan);
  return (
    <TableRow hover onClick={() => onView(plan)} style={{ cursor: 'pointer' }}>
      <TableCell>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <ProgressDonut percent={STATUS_META[plan?.status?.label]?.progress} color={STATUS_META[plan?.status?.label]?.color} />
          <div>
            <div style={{ fontWeight: 600 }}>
              <TruncatedText text={plan?.name} />
              {plan?.tag ? <Chip size="small" label={plan?.tag} style={{ marginLeft: 6 }} /> : null}
            </div>
          </div>
        </div>
      </TableCell>
      <TableCell onClick={(event) => event.stopPropagation()}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <TruncatedText text={plan?.current_stage?.name || '--'} />
          {canEditStage ? (
            <Tooltip title="Change Stage" arrow>
              <OpenInNewIcon color="primary" style={{ fontSize: '16px' }} onClick={(e) => { e.preventDefault(); e.stopPropagation(); onEditStage(plan); }} />
            </Tooltip>
          ) : null}
        </div>
      </TableCell>
      <TableCell><TruncatedText text={plan?.lessor?.name} />{plan?.client?.id === 1 ? <div><Chip style={{ fontSize: "11px", height: "18px", cursor: 'pointer', border: '1px solid #1976D2', color: '#1976D2' }} label="Client" size="small" variant="outlined" /></div> : null}</TableCell>
      <TableCell><TruncatedText text={plan?.lessee?.name} />{plan?.client?.id === 2 ? <div><Chip style={{ fontSize: "11px", height: "18px", cursor: 'pointer', border: '1px solid #1976D2', color: '#1976D2' }} label="Client" size="small" variant="outlined" /></div> : null}</TableCell>
      {/* <TableCell><TruncatedText text={plan?.inspection_type?.label || plan?.inspection_type?.name} /></TableCell> */}
      <TableCell>
        {formatPlanDate(plan?.planned_start_date)}
        {soon ? <Chip size="small" label={`${daysUntilStart(plan?.planned_start_date)}d`} style={{ marginLeft: 6, backgroundColor: '#fef3c7', color: '#92400e' }} /> : null}
      </TableCell>
      <TableCell>{formatPlanDate(plan?.planned_end_date)}</TableCell>
      <TableCell>{plan?.asset_count}</TableCell>
      <TableCell onClick={(event) => event.stopPropagation()}>
        <StatusBadge status={plan?.status} canChange={canChangeStatus} onChangeStatus={(status) => onChangeStatus(plan, status)} />
      </TableCell>
      <TableCell>{plan?.created_by?.name ? plan?.created_by?.name : '--' }</TableCell>
      <TableCell>{plan?.created_at ? moment(plan?.created_at).format(displayDateTime12HrsFormatShort) : '--'}</TableCell>
      <TableCell>{plan?.updated_by?.name ? plan?.updated_by?.name : '--' }</TableCell>
      <TableCell>{plan?.updated_at ? moment(plan?.updated_at).format(displayDateTime12HrsFormatShort) : '--'}</TableCell>
      <TableCell className='actions-cell' onClick={(event) => event.stopPropagation()}>
        <ul className="list-inline" style={{ display: "flex", float: 'right' }}>
          <li className="list-inline-item">
            <Tooltip title="View Attachment" arrow>
              <AttachFileIcon fontSize="small" color="primary" />
            </Tooltip>
          </li>
          <li className="list-inline-item">
            <Tooltip title="Edit" arrow>
              <EditIcon color="primary" fontSize="small" onClick={(e) => { e.preventDefault(); e.stopPropagation(); onEdit(plan); }} />
            </Tooltip>
          </li>
          <li className="list-inline-item">
            <Tooltip title="View" arrow>
              <VisibilityIcon color="primary" fontSize="small" onClick={(e) => { e.preventDefault(); e.stopPropagation(); onView(plan); }} />
            </Tooltip>
          </li>
          <li className="list-inline-item">
            <Tooltip title="Delete" arrow>
             <DeleteOutlineIcon color="secondary" fontSize="small" onClick={(e) => { e.stopPropagation(); onDelete(plan); }} />
            </Tooltip>
          </li>
        </ul>
      </TableCell>
    </TableRow>
  );
};

export default PlannerList;
